<template>
  <a-popup v-bind="popupProps">
    <template v-slot:activator-content>
      <slot name="activator">
        <span class="disclaimer__text">Disclaimer</span>
      </slot>
    </template>

    <template v-slot:popup-content>
      <slot name="popup">
        <disclaimer-content />
      </slot>
    </template>
  </a-popup>
</template>

<script>
import { propValidator, PROP_TYPES } from '@/utils/validators'
import APopup from '@/components/_shared/APopup'
import DisclaimerContent from './DisclaimerContent'
import { LAYOUT_ORDERING } from '../APopup/enums'
import { hydrationHelpers } from '@/utils/mixins/hydrationHelpers'

export default {
  name: 'ADisclaimer',
  mixins: [hydrationHelpers],
  components: { APopup, DisclaimerContent },
  props: {
    layoutOrdering: propValidator([PROP_TYPES.ARRAY], false, LAYOUT_ORDERING),
    topSpaceOffset: propValidator([PROP_TYPES.NUMBER], false, 0),
    bottomSpaceOffset: propValidator([PROP_TYPES.NUMBER], false, 0),
    popupSettingsByBreakpoint: propValidator([PROP_TYPES.OBJECT], false),
    showBeak: propValidator([PROP_TYPES.BOOLEAN], false, false),
    showOnAmp: propValidator([PROP_TYPES.BOOLEAN], false, false)
  },
  computed: {
    popupProps() {
      return {
        layoutOrdering: this.layoutOrdering,
        topSpaceOffset: this.topSpaceOffset,
        popupSettingsByBreakpoint: this.popupSettingsByBreakpoint,
        showBeak: this.showBeak,
        showOnAmp: this.showOnAmp
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .activator__hover-content {
  cursor: pointer;
}

.disclaimer__text {
  color: $c--disabled-text-legacy;
  font-size: 14px;
  line-height: 18px;
  margin-inline-end: 8px;
}

/deep/ .popup__container--amp {
  width: 244px;
  height: 216px;
  top: 25px;
  right: 0;
  position: absolute;
  border: 2px solid $c--main;
  padding: 12px 16px;
  border-radius: 4px;
  background: $c--gray-soft;
  z-index: $z-index-popup;

  @include mobile {
    right: unset;
    left: -50%;
  }
}
</style>
